// TODO - Need to handle import

import { CreateAggregatorType } from 'utils/schema/aggregatorSchema'
import Api from './axiosInstance'
import { API_AGGREGATOR_MGMT } from 'utils/constants'

type FetchAggregatorsParams = {
  limit: number
  page: number
  search?: string
  isActive?: boolean
  // Matches aggregatorFilterConfig on the backend (isActive, ftpIsEnable,
  // ftpIsRunning, apiIsEnable) - passed through as-is, one query param per
  // key. Used by the aggregator list's filter bar; other callers needing
  // just the isActive shortcut above don't need this.
  filters?: Record<string, string>
}

const fetchAggregators = ({
  limit,
  page,
  search,
  isActive,
  filters,
}: FetchAggregatorsParams) => {
  const options: any = { ...filters }

  if (search) {
    options.search = search
  }

  if (isActive !== undefined) {
    options.isActive = isActive
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_AGGREGATOR_MGMT.AGGREGATOR}?${params}`,
  })
}

/**
 * Get Aggregator Details
 */
const getAggregator = (aggregatorId: string) => {
  return Api.get({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${aggregatorId}` })
}

const createAggregator = (data: CreateAggregatorType) => {
  return Api.post({ url: API_AGGREGATOR_MGMT.AGGREGATOR, data: data })
}

const deleteAggregator = (id: string) => {
  return Api.delete({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}` })
}

const updateAggregator = (id: string, data: CreateAggregatorType) => {
  return Api.patch({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}`, data })
}

const generateOrderTokenAggregator = (id: string) => {
  return Api.post({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}` })
}

const triggerAggregatorApi = (id: string, data: string[]) => {
  return Api.post({
    url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}/trigger-aggregator-api`,
    data,
  })
}

const triggerFtp = (id: string, data: string[]) => {
  return Api.post({
    url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}/trigger-ftp-file`,
    data,
  })
}

// To Upload a Pricing file in server and update Pricing data
const uploadAggregatorImg = async (id: string, data: FormData) => {
  return Api.post({
    url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}/image`,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const triggerDeliverooCatalogueSync = () => {
  return Api.post({ url: `${API_AGGREGATOR_MGMT.DELIVEROO}/sync-catalogue` })
}

export const triggerDeliverooInventorySync = () => {
  return Api.post({ url: `${API_AGGREGATOR_MGMT.DELIVEROO}/sync-inventory` })
}

export const triggerDeliverooPriceSync = () => {
  return Api.post({ url: `${API_AGGREGATOR_MGMT.DELIVEROO}/sync-price` })
}

export const triggerDeliverooListingSync = () => {
  return Api.post({ url: `${API_AGGREGATOR_MGMT.DELIVEROO}/sync-listing` })
}

export {
  createAggregator,
  deleteAggregator,
  fetchAggregators,
  updateAggregator,
  getAggregator,
  generateOrderTokenAggregator,
  uploadAggregatorImg,
  triggerAggregatorApi,
  triggerFtp,
}
